import React from "react";
import Img from "gatsby-image";
import classnames from "classnames";
import SpokenLanguageList from "../lists/SpokenLanguageList";
import ExpandableList from "../lists/ExpandableList";
import Grid from "../../components/grid/Grid";
import cssClass from "./ClinicDetails.module.scss";

const ClinicDetails = ({
  className,
  image,
  pregnancyRate,
  multiplePregnancyRate,
  testimonial,
  facilities,
  services,
  spokenLanguages,
  // insurancePartners,
  email,
  address,
  officeHours,
  phone,
}) => {
  return (
    <div className={classnames(className, cssClass.detailsContainer)}>
      <div className={cssClass.imageWrapper}>
        {image && <Img fluid={image.fluid} alt={image.title} />}
      </div>
      <div className={cssClass.statsContainer}>
        <h5>Our pregnancy rates</h5>
        <p className={cssClass.subtitle}>Pregnancies per embryos transferred</p>
        <Grid columns={2}>
          {pregnancyRate && (
            <div>
              <p className="boldText">IVF</p>
              <h1 className={cssClass.statistic}>10%</h1>
              <h5>12.2%</h5>
              <p className="smallBodyText">National average*</p>
            </div>
          )}
          {multiplePregnancyRate && (
            <div>
              <p className="boldText">IVF + ICSI</p>
              <h1 className={cssClass.statistic}>10%</h1>
              <h5>15%</h5>
              <p className="smallBodyText">National average*</p>
            </div>
          )}
        </Grid>
        <p className={cssClass.statsFootnote}>
          *Registro Nacional de Actividad 2018 - Registro SEF
        </p>
      </div>
      {testimonial && (
        <div className={cssClass.quoteContainer}>
          <blockquote>
            <span>&quot;</span>
            {testimonial}
          </blockquote>
        </div>
      )}
      <div className={cssClass.unitsContainer}>
        <h5>Units and facilities</h5>
        <Grid columns={2}>
          {facilities && (
            <ExpandableList title="Facilities" stringArray={facilities} />
          )}
          {services && (
            <ExpandableList title="Facilities" stringArray={services} />
          )}
          {spokenLanguages && (
            <SpokenLanguageList spokenLanguagesArray={spokenLanguages} />
          )}
          {/* HIDDEN UNTIL MORE INFO IS READY FOR INSURANCE PARTNERS */}
          {/* {insurancePartners && (
          <div>
            <p className="boldText">Insurance Partners</p>
            <ul
              className={classnames(
                cssClass.noListStyle,
                cssClass.insurancePartnerLogoList
              )}
            >
              {insurancePartners.map((partner) => (
                <li key={partner.id}>
                  <Img
                    className={cssClass.insurancePartnerLogo}
                    fluid={partner.fluid}
                    alt={partner.title}
                  />
                </li>
              ))}
            </ul>
          </div>
        )} */}
        </Grid>
      </div>
      <div className={cssClass.mapWrapper}>map here</div>
      <div className={cssClass.contactContainer}>
        <h5>Contact us</h5>
        <Grid columns={2}>
          {address && (
            <div>
              <p className="boldText">Location</p>
              <div
                dangerouslySetInnerHTML={{
                  __html: address.childMarkdownRemark.html,
                }}
              />
              <a className="boldText" href="/">
                Get Directions
              </a>
            </div>
          )}
          {phone && (
            <div>
              <p className="boldText">Useful telephone numbers</p>
              <p>
                Calling from the UK: <br />
                <span className="boldText">{phone}</span>
              </p>
              <p>
                Other countries: <br />
                <span className="boldText">{phone}</span>
              </p>
            </div>
          )}
          {officeHours && (
            <div>
              <p className="boldText">Office hours</p>
              <ul>
                <li>clinic: {officeHours.clinic}</li>
                <li>reception: {officeHours.reception}</li>
              </ul>
            </div>
          )}
          {email && (
            <div>
              <p className="boldText">Email us</p>
              <a
                href={`mailto:${email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {email}
              </a>
            </div>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default ClinicDetails;
